import { z } from "zod";

export const BillingSchema = z.object({
  address: z.object({
    firstName: z.string().min(2).max(64, "Veuillez entrer un prénom valide"),
    lastName: z.string().min(2).max(64, "Veuillez entrer un nom valide"),
    address1: z.string().min(1),
    address2: z.string().optional(),
    city: z.string().min(1),
    zipCode: z.string().min(1),
    countryCode: z.string(),
    businessName: z.string().min(1),
  }),
  acceptedTerms: z.boolean().refine((v) => {
    return v;
  }, "Veuillez accepter les conditions d'utilisation et notre politique de confidentialité"),
  organisers: z
    .array(z.object({ id: z.string(), hasConsented: z.boolean() }))
    .optional(),
  structures: z
    .array(z.object({ id: z.string(), hasConsented: z.boolean() }))
    .optional(),
});
export type BillingForm = z.infer<typeof BillingSchema>;

export const BillingSchemaWithoutBusinessName = BillingSchema.extend({
  address: BillingSchema.shape.address.omit({
    businessName: true,
  }),
});

export const CreateTransactionSchema = z
  .object({
    orderId: z.string(),
  })
  .merge(BillingSchema);

export type CreateTransactionForm = z.infer<typeof CreateTransactionSchema>;

export const CreateTransactionWithBusinessNameSchema = z
  .object({
    orderId: z.string(),
  })
  .merge(BillingSchemaWithoutBusinessName);

export type CreateTransactionWithoutBusinessNameForm = z.infer<
  typeof CreateTransactionWithBusinessNameSchema
>;

/* export const defaultCreateTransactionValues: CreateTransactionForm = {
  orderId
} */
